import { Action } from '@ngrx/store';
import { TechnicalError, UserProduct } from '@dch/products-business-logic';

export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILED = 'GET_PRODUCTS_FAILED';
export const GET_PRODUCTS_REDIRECTED_TO_DETAILS =
  'GET_PRODUCTS_REDIRECTED_TO_DETAILS';

export class GetProducts implements Action {
  type = GET_PRODUCTS;

  constructor(public payload?: any) {}
}

export class GetProductsSuccess implements Action {
  type = GET_PRODUCTS_SUCCESS;

  constructor(public payload: UserProduct) {}
}

export class GetProductsFailed implements Action {
  type = GET_PRODUCTS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class GetProductsRedirectedToDetails implements Action {
  type = GET_PRODUCTS_REDIRECTED_TO_DETAILS;

  constructor(public payload?: any) {}
}

export type Actions =
  | GetProducts
  | GetProductsSuccess
  | GetProductsFailed
  | GetProductsRedirectedToDetails;
